import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
/**
 *
 * Paragraph
 *
 */

import React from 'react';
import classnames from 'classnames';

var Paragraph = function Paragraph(_ref) {
  var children = _ref.children,
      preformatted = _ref.preformatted,
      extraClasses = _ref.extraClasses,
      extraProps = _objectWithoutProperties(_ref, ["children", "preformatted", "extraClasses"]);

  return preformatted ? React.createElement("pre", _extends({
    className: classnames(extraClasses)
  }, extraProps), children) : React.createElement("p", _extends({
    className: classnames(extraClasses)
  }, extraProps), children);
};
/* istanbul ignore next */


Paragraph.defaultProps = {
  preformatted: false
};
Paragraph.displayName = 'Paragraph';
export default Paragraph;